<template>
  <div class="p-3">
    <div class="alert alert-warning">
      <h4>Redirecting... Please Wait.</h4>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    var form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('target', '_blank');
    let tickDomain = 'https://staging.shareware.io/';
    if (this.$store.getters['account/getEnv'] == 'prod') {
      tickDomain = 'https://tickets.shareware.io/';
    }
    form.setAttribute('action', tickDomain + 'integration/connect/auth');
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', 'token');
    hiddenField.setAttribute('value', this.$store.getters['account/getToken']);
    form.appendChild(hiddenField);

    var hiddenField2 = document.createElement('input');
    hiddenField2.setAttribute('type', 'hidden');
    hiddenField2.setAttribute('name', 'env');
    hiddenField2.setAttribute('value', this.$store.getters['account/getEnv']);
    form.appendChild(hiddenField2);
    document.body.appendChild(form); // Not sure if this step is necessary
    form.submit();
    this.$router.push({ name: 'Dashboard' });
  }
};
</script>
